import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden pt-16 md:pt-20"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-60 -left-40 w-[700px] h-[700px] rounded-full bg-accent-100/30 blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-secondary-100/20 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-16">
        <div className="w-full flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full max-w-2xl">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4 md:mb-5 whitespace-nowrap">
              {heroData.tagline}
            </span>

            <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-3 md:mb-4">
              {heroData.title}
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium mb-4 md:mb-5">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 md:mb-8 max-w-xl">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-6 md:mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={heroData.ctaPrimary.href}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {heroData.ctaPrimary.text}
              </a>
              <a
                href={heroData.ctaSecondary.href}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-800 font-medium rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-information-line text-lg"></i>
                {heroData.ctaSecondary.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none flex justify-center">
            <div className="relative w-full aspect-[4/3] max-w-[480px] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20entertainment%20streaming%20platform%20interface%20with%20vibrant%20variety%20show%20thumbnails%20and%20curved%20design%20elements%2C%20warm%20amber%20and%20coral%20accent%20colors%2C%20clean%20dark-themed%20UI%20with%20movie%20poster%20cards%2C%20professional%20web%20design%20aesthetic%2C%20sleek%20modern%20layout%20with%20glowing%20warm%20highlights&width=960&height=720&seq=hero-main-2026&orientation=landscape"
                alt="97在线影院综艺观看平台界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}